import { Dimensions } from 'react-native';

export const ultraSmallColumnWidth = (): number => {
  const { width } = Dimensions.get('window');
  return (152 / 375) * width;
};
